import { createTheme } from '@mui/material/styles';

// Paleta de cores extraída dos logos:
// Azul Principal (Nimo/Interconecta): #004792 (Dark Blue)
// Verde (Nimo Energia/Interconecta): #38A845 (Green)
// Amarelo/Laranja (Nimo): #FFC300 (Yellow/Gold)

const theme = createTheme({
  palette: {
    primary: {
      main: '#004792', // Azul Principal
      light: '#4072C4',
      dark: '#002E61',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#38A845', // Verde
      light: '#6FD17A',
      dark: '#267A31',
      contrastText: '#ffffff',
    },
    success: {
      main: '#38A845', // Verde (para sucesso)
      light: '#6FD17A',
      dark: '#267A31',
    },
    warning: {
      main: '#FFC300', // Amarelo/Laranja (para destaque)
      light: '#FFD64D',
      dark: '#CC9C00',
    },
    error: {
      main: '#f5576c',
      light: '#f77f8f',
      dark: '#d94456',
    },
    background: {
      default: '#f4f6f8',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;
